module.exports = __webpack_public_path__ + "assets/img/government1-1.75f8ae15.png";